import React from 'react';
import { Atons } from './Atons';
import { useViewMode, ViewMode } from '../../components/ViewModeProvider';
import { useSelectionState } from '../../components/SelectionStateProvider';

export const DetailAtons = React.memo(
  ({ className }: { className: string }) => {
    const { viewMode, setViewMode } = useViewMode();
    const { setAton } = useSelectionState();
    const onExit = () => {
      if (viewMode === ViewMode.Detail) {
        setViewMode(ViewMode.Normal);
      }

      setAton(null);
    };

    return <Atons className={className} onExit={onExit} requiresMap={false} />;
  }
);
